export default "__VITE_ASSET__Fcr0ZKEq__"